import {
    REQUEST_STATE,
    CORE_GET_SYSTEM_INFO_REQUEST,
    CORE_GET_SYSTEM_INFO_SUCCESS,
    CORE_GET_SYSTEM_INFO_FAILURE,
} from '../types'

const requestState = REQUEST_STATE

export default {
    info: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_SYSTEM_INFO_REQUEST:
                return state
            case CORE_GET_SYSTEM_INFO_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_SYSTEM_INFO_FAILURE:
                return {}
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/info.js